import { ref } from 'vue';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

const updateAvailable = ref(false);
const storeVersion = ref(null);
const dismissed = ref(false);

const BUNDLE_ID = 'com.luckyfridayllc.app';
const APP_STORE_ID = '6749335179';
const APP_STORE_URL = `https://apps.apple.com/app/id${APP_STORE_ID}`;

function compareVersions(a, b) {
  const partsA = a.split('.').map(Number);
  const partsB = b.split('.').map(Number);
  const len = Math.max(partsA.length, partsB.length);
  for (let i = 0; i < len; i++) {
    const diff = (partsA[i] || 0) - (partsB[i] || 0);
    if (diff !== 0) return diff;
  }
  return 0;
}

export function useAppUpdateCheck() {
  async function checkForUpdate() {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') {
      return;
    }

    if (dismissed.value) return;

    try {
      const response = await fetch(
        `https://itunes.apple.com/lookup?bundleId=${BUNDLE_ID}&t=${Date.now()}`
      );
      const data = await response.json();
      const latestVersion = data.results?.[0]?.version;

      if (!latestVersion) {
        console.warn('[UpdateCheck] No version returned from App Store');
        return;
      }

      const info = await App.getInfo();
      //   const currentVersion = info.version;
      const currentVersion =
        import.meta.env.MODE === 'qa' ? '0.0.1' : info.version;

      console.log(
        `[UpdateCheck] current: ${currentVersion}, store: ${latestVersion}`
      );

      if (compareVersions(latestVersion, currentVersion) > 0) {
        storeVersion.value = latestVersion;
        updateAvailable.value = true;
      }
    } catch (err) {
      console.warn('[UpdateCheck] Failed:', err);
    }
  }

  async function openAppStore() {
    if (Capacitor.getPlatform() === 'ios') {
      window.location.href = `https://apps.apple.com/app/id${APP_STORE_ID}`;
    } else {
      window.open(APP_STORE_URL, '_blank');
    }
  }

  function dismiss() {
    updateAvailable.value = false;
    dismissed.value = true;
  }

  return {
    updateAvailable,
    storeVersion,
    checkForUpdate,
    openAppStore,
    dismiss,
  };
}
